import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAllLecturers, useCommonContentReReg } from '../../query/hooks/QueryHooksDashboard';
import { RenderLearningMethod, RenderSchool } from '../../utils/CommonGroupingItem';
import Tablefilter from './Tablefilter';
import QueryStatus from './QueryStatus';

const HomeTopFilters = ({
    fetchDetails = { dataUpdatedAt: null, isFetching: false },
    setGlobalReset,
    setFilterIntake,
    setFilterSchool,
    setFilterLearningMethod,
    setFilterLecturer
}) => {

    const { type: urlType, tab } = useParams();
    const [school, setSchool] = useState({ arr: [], checkObj: {} })
    const [learningMethod, setLearningMethod] = useState({ arr: [], checkObj: {} });
    const [intake, setIntake] = useState({ arr: [], checkObj: {} });
    const [lecturer, setLecturer] = useState({ arr: [], checkObj: [] });
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);

    const { data: lecturerArr = [] } = useAllLecturers();
    const { data: dropdownVals } = useCommonContentReReg();
    
    const intakeArr = useMemo(() => {
        if (!dropdownVals || (!dropdownVals?.intake_year || !dropdownVals?.intake_number)) {
            return [];
        }

        const derivedIntakeArr = [];

        dropdownVals.intake_year.forEach(year => {
            dropdownVals.intake_number.forEach(number => {
                derivedIntakeArr.push({
                    value: `${year.value}/${number.label}`,
                    label: `${year.value}-${number.label}`
                });
            });
        });

        return derivedIntakeArr;
    }, [dropdownVals]);
    
    useEffect(() => {
        if (!Array.isArray(lecturer.checkObj) && Object.keys(lecturer.checkObj).length == 0) {
            setLecturer({ ...lecturer, checkObj: [] });
        }
    }, [lecturer]);

    const resetFilter = () => {
        
        setSchool({ arr: [], checkObj: {} });
        setLearningMethod({ arr: [], checkObj: {} })
        setLecturer({ arr: [], checkObj: [] })
        setIntake({ arr: [], checkObj: {} })
        setGlobalReset(true)
        // document.querySelectorAll('.filter-button-group > .assessment-table-filter input[checked]').forEach((checkbox) => {
        //     console.log("Unchecking buttons");
        //     checkbox.checked = false;
        // });
    }

    useEffect(() => {
        const storedFilters = JSON.parse(localStorage.getItem("globalDashboardFilters"));
        if (storedFilters) {
            setFilterLearningMethod(storedFilters.learningMethod.arr);
            setFilterSchool(storedFilters.school.arr);
            setFilterIntake(storedFilters.intake.arr);
            setFilterLecturer(storedFilters.lecturer.arr);
            setIntake(storedFilters.intake)
            setLecturer(storedFilters.lecturer)
            setSchool(storedFilters.school)
            setLearningMethod(storedFilters.learningMethod)
        }
    }, []);

    useEffect(
        () => {
            setFilterLearningMethod(learningMethod.arr)
            

            const filterState = {
                learningMethod,
                intake,
                school,
                lecturer
            };
            if(filterState.learningMethod.arr != [] || filterState.intake.arr != [] || filterState.school.arr != [] || filterState.lecturer.arr != []){
            localStorage.setItem("globalDashboardFilters", JSON.stringify(filterState));
            }

            // getDashboards()
            // console.log(learningMethod,"learningMethod");
        },[learningMethod]
    )

    useEffect(() => {
        setFilterLecturer(lecturer.arr)

            const filterState = {
                learningMethod,
                intake,
                school,
                lecturer
            };
            if(filterState.learningMethod.arr != [] || filterState.intake.arr != [] || filterState.school.arr != [] || filterState.lecturer.arr != []){
            localStorage.setItem("globalDashboardFilters", JSON.stringify(filterState));
            }
    },[lecturer])
    useEffect(() => {
        setFilterSchool(school.arr)
        const filterState = {
            learningMethod,
            intake,
            school,
            lecturer
        };
        if(filterState.learningMethod.arr != [] || filterState.intake.arr != [] || filterState.school.arr != [] || filterState.lecturer.arr != []){
        localStorage.setItem("globalDashboardFilters", JSON.stringify(filterState));
        }
    },[school])

    useEffect(() => {
        setFilterIntake(intake.arr)
        const filterState = {
            learningMethod,
            intake,
            school,
            lecturer
        };
        if(filterState.learningMethod.arr != [] || filterState.intake.arr != [] || filterState.school.arr != [] || filterState.lecturer.arr != []){
        localStorage.setItem("globalDashboardFilters", JSON.stringify(filterState));
        }
    },[intake])
    
    return (
        <>
            <div className="filter-button-group" style={{ position: "static", marginBottom: "15px",flexWrap:"wrap" }}>
                <Tablefilter
                    filterName="School"
                    optionArr={dropdownVals?.school_type || []}
                    state={school}
                    uniqueId="globalSchool"
                    setState={setSchool}
                    renderLabelFunction={RenderSchool}
                />
                <Tablefilter
                    filterName="Intake"
                    optionArr={intakeArr}
                    uniqueId="globalIntake"
                    state={intake}
                    isOptionReversed={true}
                    setState={setIntake}
                // renderLabelFunction={RenderClassType}
                />
                <Tablefilter
                    filterName="Learning Method"
                    optionArr={dropdownVals?.study_type || []}
                    state={learningMethod}
                    uniqueId="globalLearning"
                    setState={setLearningMethod}
                    renderLabelFunction={RenderLearningMethod}
                />
                <Tablefilter
                    filterName="Employee"
                    optionArr={lecturerArr}
                    state={lecturer}
                    uniqueId="globalLecturer"
                    setState={setLecturer}
                    isSearchFilter={true}
                />
                <div className="button-reset dropdown-comman" style={{ marginTop: "0" }}>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={resetFilter}
                        title="Reset"
                    >
                        <i className="fal fa-redo"></i>Reset
                    </button>
                </div>
                <div style={{ marginLeft: 'auto' }}>
                    <QueryStatus dataUpdatedAt={fetchDetails.dataUpdatedAt} isFetching={fetchDetails.isFetching} />
                </div>
            </div>
        </>
    );
}

export default HomeTopFilters;
